import { Link } from 'react-router';
import { Merke } from '../skall/Merke.tsx';
import { Ikon } from '../status/Ikon.tsx';
import { KART } from './Tastaturkart.tsx';

/**
 * De fem snarveiene som betyr mest for triage (DD-19): bla, åpne, sett status, svar, tilbake.
 * `tast` er nøkkelen i Tastaturkartets KART — ÉN kilde, og testen krever at hver finnes der.
 * `vis` er tastene som <kbd>, `kort` er ordet konseptets skjerm 4 viser.
 */
export const TRIAGE: ReadonlyArray<{ tast: string; vis: string[]; etter?: string; kort: string }> = [
  { tast: 'j / k', vis: ['J', 'K'], kort: 'bla' },
  { tast: 'Enter', vis: ['↵'], kort: 'åpne' },
  { tast: 's, så første bokstav', vis: ['S'], etter: '+ bokstav', kort: 'sett status' },
  { tast: 'r', vis: ['R'], kort: 'svar' },
  { tast: 'Esc', vis: ['Esc'], kort: 'tilbake' },
];

/**
 * Ruten uten valgt sak (DD-19, presisert 2026-09-09 og 2026-09-19): merket dempet, ÉN setning
 * og snarveiene som tett tabell. Er innboksen tom (`alleVurdert`), er ruten hele flaten (F14)
 * og får ÉN fylt knapp: til sakene i arbeid som har stått stille i fire uker (DD-25 presisert)
 * — tallet er innboksens telling `inactive`, som med null til vurdering bare kan være saker i
 * arbeid. Har ingen stått stille, peker knappen på Saker uten tall: tomtilstanden er alltid en
 * invitasjon til handling (DD-19).
 */
export function Tomrute({ tom, alleVurdert, stille }: { tom: boolean; alleVurdert?: boolean; stille?: number | null }) {
  const rader = TRIAGE.filter((t) => KART.some(([k]) => k === t.tast));
  return (
    <div className="panel-tomrute" data-testid="tomrute">
      <Merke storrelse="xl" dempet alene />
      {alleVurdert ? (
        <>
          <p className="panel-tomrute-tekst panel-tomrute-alle">Alt er vurdert. Nye saker lander her.</p>
          <Link to="/saker" className="panel-knapp panel-tomrute-knapp">
            {stille ? `${stille} ${stille === 1 ? 'sak' : 'saker'} i arbeid har stått stille i 4 uker · Saker` : 'Gå til Saker'}
            <Ikon navn="chevron-forward-outline" />
          </Link>
        </>
      ) : (
        <p className="panel-tomrute-tekst">{tom ? 'Når en sak lander her, viser denne ruten teksten, konteksten, statusen og svaret.' : 'Velg en sak i lista: her står teksten, konteksten, statusen og svaret.'}</p>
      )}
      <table className="panel-snarveier" aria-label="Snarveier">
        <tbody>
          {rader.map((t) => (
            <tr key={t.tast}>
              <td>
                {t.vis.map((v) => (
                  <kbd key={v}>{v}</kbd>
                ))}
                {t.etter ?? null}
              </td>
              <td>{t.kort}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
